// extracted by mini-css-extract-plugin
module.exports = {"shopButton":"styles_shopButton__35rHl","text":"styles_text__29Qrb","arrow":"styles_arrow__1RIsj"};